import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/sys/role"

const sysRole = {
  roleAllList() {
    return axios.get(pre + `/roleAllList`);
  },
  roleListPage(pageSize, limit, name) {
    return axios.get(pre + `/roleListPage`, {params: {pageSize: pageSize, limit: limit, name: name}});
  },

  saveRole(params) {
    return axios.post(pre + `/saveRole`, qs.stringify(params));
  },
  delRole(roleId) {
    return axios.delete(pre + `/delRole`, {params: {id: roleId}});
  },
  roleInfo(roleId) {
    return axios.get(pre + `/roleInfo`, {params: {id: roleId}});
  },

}
export default sysRole;



// WEBPACK FOOTER //
// ./src/api/sys/role.js